'use client';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import { useEffect } from 'react';
import Cart from '@components/Cart';
import { Drawer } from '@repo/ui/src/modules/UI/components/Drawer';
import { ModalID, useModal } from '@repo/ui/src/modules/UI';

export const CartDrawer = () => {
  const { enable, disable } = useModal(ModalID.cart);
  const { path } = useCurrentUrl();

  useEffect(() => {
    if (path.startsWith('/cart')) {
      disable();
    } else {
      enable();
    }
  }, [path, disable, enable]);

  return (
    <Drawer id={ModalID.cart}>
      <Cart />
    </Drawer>
  );
};
